import type { BarModel } from './bars.types';
import type { CellarModel } from './cellars.types';

export interface PythonModel {
  id: string;
  name: string;
  bar: BarModel;
  position: number;
  brand: BrandType;
  length: number;
  linesComb: LinesCombinationsType;
  type?: PythonType;
  cellar: CellarModel;
  cellarId: string;
  barId: string;
  remoteCoolerId: string;
}

export interface CreatePythonParams {
  venueId: string | null;
  position: number | null;
  length: number;
  brand: BrandType | null;
  linesComb: LinesCombinationsType | null;
  type: PythonType | null;
  barId: string | null;
  cellarId: string | null;
  shouldShift: boolean | null;
}

export interface UpdatePythonParams extends CreatePythonParams {
  pythonId: string | null;
}

export interface DeletePythonParams {
  pythonId: string;
}
export interface ListPythonResponse {
  result: PythonModel[];
  limit: number;
  offset: number;
  count: number;
}

export interface ListAutoCompletePythonsResponse {
  result: PythonModel[];
  count: number;
}

export enum LinesCombinationsType {
  FIRST = '10+4',
  SECOND = 'BROKEN14+4',
  THIRD = '6+2',
  CUSTOM = 'CUSTOM'
}

export enum BrandType {
  Brewmaster = 'Brewmaster 2',
  CUSTOM = 'CUSTOM'
}

export enum PythonType {
  DEFAULT = 'Default'
}

export type PythonsSortingFields = 'name' | 'length' | 'barName' | 'cellarName';
